import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import reducer, { initialState } from './utils/reducer'
import { StateProvider } from './utils/state'
import ReactNotification from 'react-notifications-component'

ReactDOM.render(
	<React.StrictMode>
		<ReactNotification />
		<StateProvider initialState={initialState} reducer={reducer}>
			<App />
		</StateProvider>
	</React.StrictMode>,
	document.getElementById('root')
)
